import React, { createContext, useEffect, useState } from "react";

import { useSearchParams } from "react-router-dom";

export const SearchDeckTabContext = createContext(null);

export function SearchDeckTabProvider({ children }) {
  const [searchParams, setSearchParams] = useSearchParams();

  const [currentStartDate, setCurrentStartDate] = useState(null);
  const [currentEndDate, setCurrentEndDate] = useState(null);
  const [currentSelectedDivisions, setCurrentSelectedDivisions] =
    useState(null);

  const urlMainDeckType = searchParams.get("main_deck_type");
  const urlSubDeckType = searchParams.get("sub_deck_type");
  const urlCardNameQueryList = searchParams.get("card_name_query_list");

  const [mainDeckType, setMainDeckType] = useState(
    urlMainDeckType || "指定なし",
  );
  const [subDeckType, setSubDeckType] = useState(urlSubDeckType || "指定なし");
  const [cardNameQueryList, setCardNameQueryList] = useState(
    urlCardNameQueryList
      ? JSON.parse(urlCardNameQueryList)
      : [{ card_names: [], card_num: 1, condition: "以上" }],
  );

  const [items, setItems] = useState({
    stats: [],
    decks_by_category: [],
    time_history: [],
  });
  const [triggerSearch, setTriggerSearch] = useState(false);

  useEffect(() => {
    if (urlMainDeckType || urlSubDeckType || urlCardNameQueryList) {
      const newParams = new URLSearchParams(searchParams);
      newParams.delete("main_deck_type");
      newParams.delete("sub_deck_type");
      newParams.delete("card_name_query_list");
      setSearchParams(newParams);
    }
  }, [
    urlMainDeckType,
    urlSubDeckType,
    urlCardNameQueryList,
    searchParams,
    setSearchParams,
  ]);

  return (
    <SearchDeckTabContext.Provider
      value={{
        mainDeckType,
        setMainDeckType,
        subDeckType,
        setSubDeckType,
        cardNameQueryList,
        setCardNameQueryList,
        items,
        setItems,
        currentStartDate,
        setCurrentStartDate,
        currentEndDate,
        setCurrentEndDate,
        currentSelectedDivisions,
        setCurrentSelectedDivisions,
        triggerSearch,
        setTriggerSearch,
      }}
    >
      {children}
    </SearchDeckTabContext.Provider>
  );
}
